module.exports = __webpack_public_path__ + "img/twitter.ecca44d9.svg";